// extracted by mini-css-extract-plugin
export default {"container":"RecruiterCandidateCard_container__NUbJx","nameWrap":"RecruiterCandidateCard_nameWrap__FqM1n","detailsWrap":"RecruiterCandidateCard_detailsWrap__M0xkX"};